<!-- quick actions removed from header; shown inside the list below -->
<div class="t-list-search">
    <tui-textfield iconStart="@tui.search" size="s">
        <input placeholder="Search categories" tuiTextfield [(ngModel)]="value" [ngModelOptions]="{standalone: true}" />
    </tui-textfield>
</div>
<hr />
<tui-data-list emptyContent="No results found" (keydown)="onKeyDown($event.key)" size="m">
    <tui-opt-group>
        <!-- My Self / Add Team at top of list -->
        <button *ngIf="!value || matchesSearch(currentUserLabel) || matchesSearch(getUserContact(currentUser)) || matchesSearch(getUserRole(currentUser))" tuiOption type="button" [value]="'My Self'" (click)="onMySelfClick()" size="m" appearance="flat">
            {{ currentUserLabel }} (you) <ng-container *ngIf="getUserMeta(currentUser)"> • <span class="email">{{
                    getUserMeta(currentUser) }}</span></ng-container>
        </button>
        <button *ngIf="!value || matchesSearch('Add Team')" tuiOption type="button" [value]="'Add Team'" (click)="onAddTeamClick()" size="m"
            class="add-team-divider">
            Add Team
        </button>
        <div class="border-bottom" *ngIf="!value"></div>

        <ng-container *ngIf="!value">
            <button *ngFor="let item of items" tuiOption type="button" [value]="item.items" size="m">
                {{ item.name }} only
            </button>
        </ng-container>

        <!-- Loading state -->
        <div *ngIf="isLoading" style="padding: 0.5rem;">
            Loading team members...
        </div>

        <!-- Error state -->
        <div *ngIf="error" style="padding: 0.5rem; color: red;">
            {{ error }}
        </div>

        <!-- Users list -->
        <div *ngIf="!isLoading && !error && filteredUsers.length > 0">
            <!-- <h4>Team Members</h4> -->
            <button *ngFor="let user of filteredUsers" tuiOption type="button" [value]="user" (click)="onUserSelect(user)">
                {{ getUserDisplayName(user) }} <ng-container *ngIf="getUserMeta(user)">• <span class="email">{{ getUserMeta(user)
                        }}</span></ng-container>
            </button>
        </div>

        <!-- No users message -->
        <div *ngIf="!isLoading && !error && filteredUsers.length === 0" style="padding: 0.5rem; color: #666;">
            No team members found
        </div>




    </tui-opt-group>
    <ng-container *ngFor="let item of items">
        <tui-opt-group *tuiLet="item.items | tuiFilter: filter : value as filtered" [label]="item.name">
            <tui-opt-group *ngIf="filtered.length" tuiMultiSelectGroup>
                <button *ngFor="let item of filtered" tuiOption type="button" [value]="item">
                    {{ item }}
                </button>
            </tui-opt-group>
        </tui-opt-group>
    </ng-container>
</tui-data-list>